import { ContextWrapper } from "@common/contexts";
import { SRClientCommunicationListingModel } from "@common/models/signalRTransport/SRClientCommunicationListingModel";
import { BaseHub, BaseHubClientMethod, BaseHubInitOptions, BaseHubMethods } from "@common/stores/hubs/BaseHub";
import { makeObservable } from "mobx";


export type ClientSMSHubMethods = BaseHubMethods & {
    joinClientSMSGroup: (clientId: number,storeId: number) => void;
    leaveClientSMSGroup: (clientId: number,storeId: number) => void;
};

export type ClientSMSHubClientMethod = BaseHubClientMethod | 
    { eventName: "onNewClientSMSMessage", callback: (clientCommunication: SRClientCommunicationListingModel) => void };

export class ClientSMSHub extends BaseHub {
    private static _currentInstance: ClientSMSHub | undefined;

    protected constructor(options: Omit<BaseHubInitOptions, "hubName">) {
        super({ hubName: "clientSMSHub", ...options });
        makeObservable(this, undefined);
        (globalThis as any)["clientSMSHub"] = this;
    }

    public static get currentInstance() {
        if (ClientSMSHub._currentInstance === undefined)
            ClientSMSHub._currentInstance = new ClientSMSHub({ isMock: appEnv.USEMOCK, env: appEnv.ENV });
        return ClientSMSHub._currentInstance;
    }

    //#region Transmit Methods

    joinClientSMSGroup = async (clientId: number,storeId: number) => {
        await this.safeInvoke<ClientSMSHubMethods, "leaveClientSMSGroup", boolean>("leaveClientSMSGroup", clientId,storeId);
        let joinedgroup = await this.safeInvoke<ClientSMSHubMethods, "joinClientSMSGroup", boolean>("joinClientSMSGroup", clientId,storeId);
        return joinedgroup;
    }

    leaveClientSMSGroup = async (clientId: number,storeId: number) => {
        var leftGroup = await this.safeInvoke<ClientSMSHubMethods, "leaveClientSMSGroup", boolean>("leaveClientSMSGroup", clientId,storeId);
        return leftGroup;
    }

    //#endregion

    //#region Base Methods

    public override registerMethod(event: ClientSMSHubClientMethod) {
        super.registerMethod(event);
    }

    public override unregisterMethod(event: ClientSMSHubClientMethod) {
        super.unregisterMethod(event);
    }

    override getExtraQueueMethodsToClean() {
        return ["joinClientSMSGroup"];
    }

    //#endregion

  
}

export const ClientSMSHubContext = new ContextWrapper<ClientSMSHub>();
